import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;

// "Last checked" text for the Google Calendar page. Under a day it counts minutes and
// hours. From a day on it counts calendar days in the account zone, so "yesterday" means
// the day before today in that zone, not 24 hours ago. This file is separate from
// formatTime.js because onboarding imports formatTime.js (R1-L5-016).
export default function relativeTime(date, zone, now = new Date()) {
  const then = dayjs(date);
  if (!date || !then.isValid()) return '';

  const elapsed = dayjs(now).diff(then);
  if (elapsed < MINUTE) return 'just now';
  if (elapsed < HOUR) {
    const minutes = Math.floor(elapsed / MINUTE);
    return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
  }

  // The day strings are read as UTC dates, so a DST change in the zone cannot make a
  // day 23 or 25 hours long here.
  const dayOf = (instant) => dayjs.utc(dayjs(instant).tz(zone).format('YYYY-MM-DD'));
  const days = dayOf(now).diff(dayOf(then), 'day');
  if (elapsed < 24 * HOUR || days < 1) {
    const hours = Math.floor(elapsed / HOUR);
    return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
  }
  return days === 1 ? 'yesterday' : `${days} days ago`;
}
